import { Container, Grid, makeStyles } from "@material-ui/core";
import AuthLogin from "../../components/auth-signup/AuthLogin";
import HeaderLogo from "../../components/header-logo/HeaderLogo";
import { useDispatch } from "react-redux";
import { setUser } from "../../store/slices/UserSlice";
import { Link, Redirect } from "react-router-dom";
import { useState } from "react";

const useStyles = makeStyles(() => ({
  root: {
    height: "100vh",
    background: "linear-gradient(to right, #243B55, #141E30)",
    padding: 0,
    paddingTop: "5rem",
    fontFamily: "Roboto",
  },
  authCard: {
    background: "rgb(255 255 255,  0)",
    WebkitBackdropFilter: "saturate(180%) blur(20px)",
    borderRadius: "1rem",
  },
  authCardTitle: {
    background: "#2196f345",
    color: "#fff",
    padding: "2rem",
    borderRadius: "1rem",
  },
  text: {
    fontFamily: "Poppins",
  },
  signInBtn: {
    marginTop: "1rem",
    padding: "1rem",
  },
}));

const Auth = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const setUserData = (userData) => {
    dispatch(setUser(userData));
    localStorage.setItem("token", userData.uid);
    setIsLoggedIn(true);
  };

  if (isLoggedIn) return <Redirect to={"/home"} />;

  return (
    <>
      <HeaderLogo />
      <Container className={classes.root} maxWidth="xl">
        <Container maxWidth="xs">
          <Grid container className={classes.authCard}>
            <Grid container>
              <Grid item xs={12} className={classes.authCardTitle}>
                <h2 className={classes.text}>
                  Welcome to <span style={{ fontWeight: 900 }}>visAR</span>
                </h2>
                <h6 className={classes.text}>
                  Visualize any product within minutes!
                </h6>
              </Grid>
            </Grid>
            <Grid container>
              <AuthLogin setUser={setUserData} />
            </Grid>
            <Grid container>
              <h5
                style={{ color: "#acacac" }}
                className={`w-100 p-3 text-center ${classes.text}`}
              >
                Powered by XR Central
              </h5>
            </Grid>
          </Grid>
        </Container>
      </Container>
    </>
  );
};

export default Auth;
